import { postV1, getV1, getGFT, postGFT, putV1 } from '@/common/utils/ajax'

const VERSION = 'v1'

const getVipCheckins= () => getGFT(`${VERSION}/vip_checkins`)

const getVipStatus = () => getGFT(`${VERSION}/vip`)

const sign = () => postGFT(`${VERSION}/vip_checkins`)

const getGoodsList = (params) => getGFT(`${VERSION}/vip_goods`, params)

const getGoodsDetail = (id) => getGFT(`${VERSION}/vip_goods/${id}`)

const getGoodsOrder = (params) => getGFT(`${VERSION}/vip_good_orders`, params)

const getCoinJournals = (params) => getGFT(`${VERSION}/vip_coin_journals`, params)

const getScoreJournals =  (params) => getGFT(`${VERSION}/vip_score_journals`, params)

const getCaptchas = (mobile) => getGFT(`${VERSION}/sms_captcha`, { mobile })

const submitOrder = (params) => postGFT(`${VERSION}/vip_good_orders`, params)

const setNotification = (params) => postV1('subscribed_notifications', params)

const getNotification = () => getV1('subscribed_notifications')

const checkSubmit = (params) =>  getGFT(`${VERSION}/vip_good_orders/new`, params)

const becomeVip = () => { return postV1('vip') }

const getVipScoreJournals = (params) => { return getV1('vip_score_journals', params) }

const saveVipMsg = (params) => { return putV1('user', params) }

const getAvatarMounts = () => { return getV1('avatar_mounts') }

const setUserAvatarMounts = (params) => { return postV1('user_avatar_mounts', params) }

export default {
    becomeVip,
    getVipScoreJournals,
    saveVipMsg,
    getAvatarMounts,
    setUserAvatarMounts,
    checkSubmit,
    getVipCheckins,
    getVipStatus,
    sign,
    getGoodsList,
    getGoodsDetail,
    getGoodsOrder,
    getCoinJournals,
    getScoreJournals,
    getCaptchas,
    submitOrder,
    setNotification,
    getNotification
}
